import { createSelector } from 'reselect'

const locales = locales => {
  return locales
}

const mapForDropdown = (locales = []) => {
  return locales.map(item => ({ value: item.id, label: item.name }))
}

export default createSelector(locales, mapForDropdown)
